// src/pages/Explore.jsx
import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ExploreFeed from "../components/Dashboard/ExploreFeed";
import MorningBrew from "../components/Dashboard/MorningBrew";
import { Compass } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import api from "../api/axios";

export default function Explore() {
  const { user } = useAuth();

  // if (!user) return null; // Removed for Public Access

  const recommendedCats = user?.seeker?.categories?.map(c => c.categoryId).join(",") || "";

  return (
    <div className="max-w-5xl mx-auto px-6 py-10">
      <div className="mb-6 text-center">
        <h1 className="text-3xl font-display font-bold mb-2 text-gray-900 dark:text-gray-100 flex items-center justify-center gap-3">
          <Compass className="w-8 h-8 text-brand-blue" /> Explore Wisdom
        </h1>
        <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
          Discover articles, stories, and guidance curated for your journey.
        </p>
      </div>

      {/* Morning Brew Widget */}
      <MorningBrew user={user} />

      {/* Dynamic Feed */}
      <ExploreFeed
        userCategories={recommendedCats}
        showFilters={true}
      />
    </div>
  );
}
